import * as React from 'react';
import DraggableChipList, {
  IItem,
} from '../../../../../../../BaseComponents/Chip/DraggableChip/EDDraggableChipList';
import { ISumData } from '../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import EDCheckbox from '../../../../../../../BaseComponents/Checkboxes/EDCheckbox';

interface IProps {
  sums: ISumData[];
  newSums: ISumData[];
  onUpdate: (sums: ISumData[]) => void;
  onChipSelectionUpdate: (expandedLevel: number) => void;
  changed: boolean;
  expandedSumLevel: number;
  visaSummeringar: boolean;
  onVisaSummeringarChanged: (show: boolean) => void;
}

/**
 * Chiplista över summeringsbegrepp
 */
class EkonomiskAnalysSums extends React.PureComponent<IProps> {
  onSelectedSumsUpdate = (chipList: IItem[]) => {
    let sums: ISumData[] = [];
    chipList.forEach(x => {
      const sum = this.props.sums.find(y => y.Namn === x.name);

      if (sum) {
        sums.push(sum);
      }
    });

    this.props.onUpdate(sums);
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <EDCheckbox
          label="Visa summeringar"
          checked={this.props.visaSummeringar}
          onCheck={this.props.onVisaSummeringarChanged}
          color="primary"
        />
        <DraggableChipList
          items={this.props.sums.map(
            (sum, index): IItem => ({
              name: sum.Namn ? sum.Namn : 'Namn Saknas',
              id: sum.Namn ?? 'NamnSaknas',
              avatarHighLighted: index <= this.props.expandedSumLevel,
            })
          )}
          onItemsUpdate={this.onSelectedSumsUpdate}
          onChipSelectionUpdate={this.props.onChipSelectionUpdate}
          canDelete
          chipSelection={this.props.visaSummeringar}
        />
      </div>
    );
  }
}

export default EkonomiskAnalysSums;
